module.exports = __webpack_public_path__ + "img/jetrodder_stopped.8ab16325.svg";